import { Fragment } from 'react';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import { paths } from 'configuration/paths';
import { SurveyResponse } from 'types/surveyResponse';
import { TranslationsKeys, useTranslate } from 'hooks/useTranslate';
import { SurveyStepperSteps } from './types';
import styles from './SurveyStepper.module.scss';

interface IProps {
  surveyResponse?: SurveyResponse | null;
  activeStep: SurveyStepperSteps;
}

export const SurveyStepper = ({ surveyResponse, activeStep }: IProps): JSX.Element => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  
  const steps = [
    { 
      key: SurveyStepperSteps.Intro,
      name: t(TranslationsKeys.surveyStepper_step_intro),
      link: surveyResponse ? paths.surveyIntroExistingSurvey.replace(':surveyId', surveyResponse.id) : null
    },
    {
      key: SurveyStepperSteps.Survey,
      name: t(TranslationsKeys.surveyStepper_step_survey),
      link: surveyResponse ? paths.survey.replace(':surveyId', surveyResponse.id) : null
    },
    {
      key: SurveyStepperSteps.WrapUp,
      name: t(TranslationsKeys.surveyStepper_step_wrapUp),
      link: surveyResponse ? paths.surveyWrapUp.replace(':surveyId', surveyResponse.id) : null
    }
  ];
  
  return (
    <div className={styles.surveyStepper}>
      <ol className={styles.surveyStepperSteps}>
        {steps.map((step) => <Fragment key={step.key}>
          <li className={step.key === activeStep ? styles.surveyStepperStepsActiveStep : ''} onClick={() => {
            if (step.link && step.key !== activeStep) {
              navigate(step.link);
            }
          }}>
            {step.link && step.key !== activeStep ? <Link to={step.link}>{step.name}</Link> : step.name}
          </li>
          {steps.indexOf(step) < steps.length - 1 && <li className={styles.surveyStepperStepsDivider}></li>}
        </Fragment>)}
      </ol>
    </div>
  );
};
